// extracted by mini-css-extract-plugin
export default {"actions":"Header_actions__5NpqN","logo":"Header_logo__G+ea6"};